import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../lib/api';

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await authAPI.forgotPassword(email);
            // On success or any error other than network failure, show the same neutral message
            setSuccess(true);
        } catch (err) {
            // If there's no response (network error), show error message
            if (!err.response) {
                setError('Could not reach the server. Please try again.');
            } else {
                // For any other error, show the neutral message
                setSuccess(true);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        }}>
            <div style={{
                background: 'white',
                padding: '40px',
                borderRadius: '12px',
                boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
                width: '100%',
                maxWidth: '400px'
            }}>
                <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <h1 style={{ color: '#333', fontSize: '28px', marginBottom: '10px' }}>
                        Forgot your password?
                    </h1>
                    <p style={{ color: '#666' }}>
                        Enter your email to receive a reset link
                    </p>
                </div>

                {success ? (
                    <div className="alert alert-success" style={{ marginBottom: '20px' }}>
                        If an account exists for that email, we've sent a link to reset your password. Check your inbox (and spam folder).
                    </div>
                ) : (
                    <>
                        {error && (
                            <div className="alert alert-error" style={{ marginBottom: '20px' }}>
                                {error}
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label className="form-label">Email Address</label>
                                <input
                                    type="email"
                                    className="form-input"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    placeholder="your@email.com"
                                    disabled={loading}
                                />
                            </div>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                style={{ width: '100%', padding: '12px', fontSize: '16px' }}
                                disabled={loading}
                            >
                                {loading ? 'Sending...' : 'Send reset link'}
                            </button>
                        </form>
                    </>
                )}

                <div style={{ marginTop: '20px', textAlign: 'center' }}>
                    <Link to="/login" style={{ color: '#667eea', textDecoration: 'none' }}>
                        ← Back to sign in
                    </Link>
                </div>
            </div>
        </div>
    );
}